import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  Component,
  inject,
  ViewChild,
  OnInit,
  DestroyRef,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';

import {
  WorkplaceTypeCreateModalComponent,
  TypeOfJob,
  BusinessService,
  Business,
} from '../../../index';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ModalAlertComponent } from '@shared/components';
import { WorkplaceTypeService } from '../../../services/workplace-type.service';
import { ToastAlertService } from '@core/services';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AsyncPipe, NgIf } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { ButtonComponent } from '@shared/components/button/button.component';
import { SearchFieldComponent } from '@shared/components/search-field/search-field.component';
import { ToolbarComponent } from '@shared/components/toolbar/toolbar.component';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Cookies } from 'typescript-cookie';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { Observable, map, startWith } from 'rxjs';

@Component({
  templateUrl: './workplace-type-page.component.html',
  styles: [],
  standalone: true,
  imports: [
    ToolbarComponent,
    SearchFieldComponent,
    ButtonComponent,
    MatCardModule,
    MatTableModule,
    MatSortModule,
    NgIf,
    MatFormFieldModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatPaginatorModule,
    MatOptionModule,
    MatSelectModule,
    MatAutocompleteModule,
    AsyncPipe,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
  ],
})
export class WorkplaceTypePageComponent implements OnInit {
  paginatorIntl: MatPaginatorIntl = new MatPaginatorIntl();
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  private businessId: number | null | undefined;
  private businessService = inject(BusinessService);
  public bussines: Business[] = [];
  public selectedBussines = -1;
  myControl = new FormControl('');

  displayedColumns: string[] = [
    'name',
    'description',
    'recurrence',
    'defaultDuration',
    'isParking',
    'business',
    'options',
  ];
  dataSource: MatTableDataSource<TypeOfJob>;
  fielInput!: string;
  private dialog = inject(MatDialog);
  private workplaceTypeService = inject(WorkplaceTypeService);
  private alertService = inject(ToastAlertService);
  private destroyRef = inject(DestroyRef);
  constructor() {
    this.paginatorIntl = new MatPaginatorIntl();
    this.dataSource = new MatTableDataSource();
  }
  ngOnInit(): void {
    this.role();
    this.getBusiness();
    const business = Cookies.get('bussinesId');
    if (business != null) {
      this.businessId = parseInt(business.toString());
      console.log('Business', this.businessId);
      this.selectedBussines = this.businessId;
      this.chargueWokplaceType(this.selectedBussines);
    } else {
      this.selectedBussines = -1;
      this.businessId = null;
    }

    //this.chargueWokplaceType();
  }
  isrole: boolean = false;
  role() {
    const role = Cookies.get('role');
    if (role && role === 'ADMINISTRADOR') {
      this.isrole = true;
    } else {
      this.isrole = false;
    }
  }
  filteredOptions: Observable<Business[]> = new Observable<Business[]>(
    observer => {
      observer.next([]);
    }
  );
  public selectedBussinesName = '';

  onOptionSelected(value: number, name: string) {
    this.selectedBussines = value;
    this.selectedBussinesName = name;
    this.myControl.setValue(this.selectedBussinesName);
    this.applyFilter();
  }

  applyFilter() {
    const value = this.myControl.value;
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(value),
      map(value => this._filter(value))
    );
  }
  private _filter(value: string | null): Business[] {
    const filterValue = (value || '').toLowerCase();
    // Actualiza el valor de búsqueda anterior
    if (!filterValue) {
      return this.bussines;
    }
    return this.bussines.filter(
      bussines =>
        this.removeDiacritics(bussines.name.toLowerCase()).includes(
          this.removeDiacritics(filterValue)
        ) ||
        (bussines.idBusiness !== undefined &&
          bussines.idBusiness.toString().includes(filterValue))
    );
  }

  removeDiacritics(text: string): string {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }
  ValidBusiness_id(): boolean {
    return this.businessId === null;
  }
  private getBusiness() {
    this.businessService
      .getBusiness()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (request: any) => {
          if (request.code === 10000) {
            this.bussines = request.reply;
            this.filteredOptions = this.myControl.valueChanges.pipe(
              startWith(''),
              map(value => this._filter(value))
            );
          }
        },
      });
  }

  chargueWokplaceType(idBusiness?: number) {
    this.workplaceTypeService
      .getWorkplaces(this.selectedBussines)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (resp: any) => {
          if (resp.code === 10000) {
            this.dataSource = new MatTableDataSource(resp.reply);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.spanish();
          } else {
            this.alertService.error(resp.detail);
          }
        },
      });
  }

  modalAction(action?: TypeOfJob) {
    let width: string;
    if (window.innerWidth <= 768) {
      // Pantallas pequeñas como dispositivos móviles
      width = '90%';
    } else {
      // Pantallas grandes
      width = '50%';
    }
    const dialogActionDetail = this.dialog.open(
      WorkplaceTypeCreateModalComponent,
      {
        width: width,
        data: {
          action: action,
          businessId: this.selectedBussines,
        },
        disableClose: true,
      }
    );
    dialogActionDetail
      .beforeClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        if (result) {
          this.chargueWokplaceType();
        }
      });
  }

  modalDelete(action: TypeOfJob) {
    const dialogDelete = this.dialog.open(ModalAlertComponent, {
      data: action?.name,
      disableClose: true,
    });
    dialogDelete
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result: boolean) => {
        if (!result) return;
        this.workplaceTypeService
          .deleteWorkplace(action.workplacetypeid)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe({
            next: resp => {
              if (resp.code === 10000) {
                this.chargueWokplaceType();
                this.alertService.sucess('Tipo de trabajo eliminado');
              } else {
                this.alertService.error(resp.detail);
              }
            },
          });
      });
  }

  spanish() {
    if (this.paginator) {
      this.paginator._intl.itemsPerPageLabel = 'Registros por página';
      this.paginator._intl.nextPageLabel = 'Página siguiente ';
      this.paginator._intl.previousPageLabel = 'Página anterior';
      this.paginator._intl.firstPageLabel = 'Primera página';
      this.paginator._intl.lastPageLabel = 'Última página';
      // Configuración del texto de la última página
      this.paginator._intl.getRangeLabel = (
        page: number,
        pageSize: number,
        length: number
      ) => {
        if (length === 0 || pageSize === 0) {
          return `0 de ${length}`;
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        const endIndex =
          startIndex < length
            ? Math.min(startIndex + pageSize, length)
            : startIndex + pageSize;
        return `${startIndex + 1} - ${endIndex} de ${length}`;
      };
    }
  }
}
